export default __webpack_public_path__ + "static/media/alertOne.ddd144df.mp3";